export const DESIGN_MANAGER_PRO = 'PRO';
export const DESIGN_MANAGER_STANDARD = 'STANDARD';
export const DESIGN_MANAGER_UPGRADE_SUBMITTED = 'DM_UPGRADE_REQUEST_SUBMITTED';

export const PAGE_MESSAGES = {
    success: 'success',
    error: 'error',
    noAuthCode: 'noAuthCode',
    noUserId: 'noUserId',
};

export function getAuthUrl(designManagerParams) {
    const searchParams = new URLSearchParams({
        /* eslint-disable camelcase */
        client_id: designManagerParams.clientId,
        response_type: 'code',
        redirect_uri: `${window.location.origin}/connect/design-manager/`,
        state: 'placeholder',
        scope: designManagerParams.scopes,
        /* eslint-enable camelcase */
    });
    return `${designManagerParams.authorizationCodeUrl}?${searchParams.toString()}`;
}

export function listenWindowClose(targetWindow) {
    return new Promise(resolve => {
        const interval = setInterval(() => {
            try {
                if (targetWindow === null || targetWindow.closed) {
                    clearInterval(interval);
                    resolve();
                }
            } catch (e) {
                clearInterval(interval);
                resolve();
            }
        }, 500);
    });
}

export function getNewBrowserWindowOptions() {
    const width = 665;
    const height = 500;
    const sW = screen.width;
    const sH = screen.height;
    let left = 0;
    let top = 0;
    if (sW > width) {
        const halfWidth = width / 2;
        const halfSW = sW / 2;
        left = Math.round(halfSW - halfWidth);
    }
    if (sH > height) {
        const halfHeight = height / 2;
        const halfSH = sH / 2;
        top = Math.round(halfSH - halfHeight);
    }
    const options = {
        width,
        height,
        toolbar: 'no',
        resizable: 'no',
        scrollbars: 'yes',
        left,
        top,
    };
    return Object.keys(options)
        .map(key => `${key}=${options[key]}`)
        .join(',');
}

/*
 *  https://1stdibs.atlassian.net/browse/TRADE-4151
 *  https://stackoverflow.com/questions/29392422/how-can-i-tell-resttemplate-to-post-with-utf-8-encoding
 *
 *  Title Char Limit for DM is actually 45, but our BE is unable to properly handle UTF-8 charactes, e.g. `ä`
 *  These characters are instead sent to DM as `a¨`. The issue seems to be related to the issue described in the above SO post,
 *  but the solutions proposed in the thread weren't able to resolve the issue on our BE.
 *
 *  Lowering this character count gives us buffer room for the title string.
 *  When https://1stdibs.atlassian.net/browse/TRADE-4187 is released this should be raised back to 45
 */
export const TITLE_CHAR_LIMIT = 40;
export function getShortTitle(title) {
    if (title.length > TITLE_CHAR_LIMIT) {
        return `${title.substring(0, TITLE_CHAR_LIMIT - 3)}...`;
    }
    return title;
}
